var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as smsActions from '../actions/sms-blast.action';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { SmsBlastService } from '../../sms-blast/sms-blast.service';
var SmsBlastEffects = /** @class */ (function () {
    function SmsBlastEffects(actions, smsBlastService) {
        var _this = this;
        this.actions = actions;
        this.smsBlastService = smsBlastService;
        this.sendSMS = this.actions.ofType(smsActions.ADD_SMS)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (payload) {
            return _this.smsBlastService.sendSMS(payload)
                .map(function (res) { return new smsActions.AddSmsSuccess(res); })
                .catch(function (error) { return of(new smsActions.AddSmsError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SmsBlastEffects.prototype, "sendSMS", void 0);
    return SmsBlastEffects;
}());
export { SmsBlastEffects };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/effects/sms-blast.effects.ts.pre-build-optimizer.js